// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3ifDZ","options":"AnswerScale_options__1gM34","selected":"AnswerScale_selected__2PLJp"};